// utils/lpPerf/variants.ts — konvensi varian gambar + rewrite render.
// Budget: sm ≤15KB/256px (logo/avatar), md ≤45KB/640px (konten LP).
// Rewrite SELALU + onerror fallback ke asli (varian bisa belum ada).
// Hanya URL storage Supabase (thumbnail YouTube dkk tidak disentuh).
export type VariantSize = 'sm' | 'md';

export const VARIANT_PRESETS: Record<VariantSize, { max: number; budget: number }> = {
    sm: { max: 256, budget: 15 * 1024 },
    md: { max: 640, budget: 45 * 1024 },
};

/** Sisipkan -sm/-md sebelum ekstensi. Bukan varian → null. */
export function variantUrl(url: string, size: VariantSize): string | null {
    const m = /^(https?:\/\/[^?#]+\/)([^/?#]+)\.(webp|jpe?g|png)((?:[?#].*)?)$/i.exec(url);
    if (!m || !url.includes('supabase.co/storage')) return null;
    if (new RegExp(`-${size}$`, 'i').test(m[2])) return null;
    return `${m[1]}${m[2]}-${size}.${m[3].toLowerCase()}${m[4]}`;
}

const withFallback = (tag: string, orig: string, small: string): string => {
    if (orig.includes("'") || /\sonerror\s*=/i.test(tag)) return tag;
    const swapped = tag.replace(orig, small);
    if (swapped === tag) return tag;
    return swapped.replace(/<img\b/i, `<img onerror="this.onerror=null;this.src='${orig}'"`);
};

/** Rewrite 1 tag img ke varian (+fallback). Bukan kandidat → tag utuh. */
export function rewriteImgTag(tag: string, size: VariantSize): string {
    const src = /\ssrc="([^"]+)"/i.exec(tag)?.[1] || '';
    if (!src || src.startsWith('data:') || src.includes('via.placeholder.com')) return tag;
    if (/\.gif(\?|#|$)/i.test(src)) return tag;
    const small = variantUrl(src, size);
    return small ? withFallback(tag, src, small) : tag;
}

/** Rewrite semua img konten → varian. Idempoten. Return {html, n}. */
export function rewriteContentImages(html: string, size: VariantSize): { html: string; n: number } {
    let n = 0;
    const out = html.replace(/<img\b[^>]*>/gi, tag => {
        const r = rewriteImgTag(tag, size);
        if (r !== tag) n++;
        return r;
    });
    return { html: out, n };
}

/** Logo footer → sm (+fallback). width/height 36 sudah di template. */
export function rewriteFooterLogo(footerHtml: string, logoUrl: string): string {
    if (!logoUrl) return footerHtml;
    const small = variantUrl(logoUrl, 'sm');
    if (!small || !footerHtml.includes(`src="${logoUrl}"`)) return footerHtml;
    if (logoUrl.includes("'")) return footerHtml;
    return footerHtml.replace(`src="${logoUrl}"`,
        `src="${small}" onerror="this.onerror=null;this.src='${logoUrl}'"`);
}
